type STYPE = 'inner' | 'outer';
type SEVER_TYPE = 'mpc' | 'ip';
// 系统类型，区分内外包项目
let $sType = 'inner';
let $severType: SEVER_TYPE = 'mpc';

// query 参数 service：用于显式指定服务类型的参数名
const SERVICE_QUERY_PARAM = 'service';
// query 参数 service 取值：ip 服务
const SEVER_TYPE_IP: SEVER_TYPE = 'ip';

const prodHostNameMap = {
  inner: 'mpc.pm.netease.com',
  outer: 'mpc.netease.com',
};

// IP 外包生产域名：isProdHostName（生产环境判断）与 isIpProdHostName（免登判断）共用
const IP_PROD_HOST_NAME = 'mpc-ip.netease.com';

function setSType(type: STYPE) {
  $sType = type;
}

function isProdHostName() {
  const hostName = window.location.hostname?.toLowerCase();
  // 生产域名 = 常规内外包生产域名（prodHostNameMap）+ IP 外包生产域名（mpc-ip.netease.com）。
  // 否则 IP 生产环境会被误判为非正式环境，错误显示"非正式环境"标识。
  return prodHostNameMap[$sType] === hostName || hostName === IP_PROD_HOST_NAME;
}

// 判断 hostname 是否为 localhost 或 IPv4 地址
function isLocalhostOrIp(hostName: string): boolean {
  if (hostName === 'localhost' || hostName === '127.0.0.1') {
    return true;
  }
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(hostName);
}

// 通过域名判断是否有 mpc-ip 判断是否是 ip 服务
function getSeverType() {
  const hostName = window.location.hostname?.toLowerCase();
  if (hostName.indexOf('mpc-ip') > -1) {
    $severType = 'ip';
  }
  // 或者当域名是 ip 或 localhost 时，且 query 中包含 service=ip 时，也认为是 ip 服务
  const searchParams = new URLSearchParams(window.location.search);
  if (
    isLocalhostOrIp(hostName) &&
    searchParams.get(SERVICE_QUERY_PARAM) === SEVER_TYPE_IP
  ) {
    $severType = SEVER_TYPE_IP;
  }

  return $severType;
}

// 是否外包场景下的 IP 服务（IP 服务不走中台登录与接口转换）
function isOuterIpService(): boolean {
  return $sType === 'outer' && getSeverType() === SEVER_TYPE_IP;
}

// 是否 IP 外包生产域名（生产环境禁止开发免登）
function isIpProdHostName(): boolean {
  const hostName = window.location.hostname?.toLowerCase();
  return hostName === IP_PROD_HOST_NAME;
}

// 外包项目标题（IP 服务场景替换为 IP 合作版权方标题）
const OUTER_TITLE = '网易游戏市场推广协同管理平台';
const IP_OUTER_TITLE = '网易游戏IP合作版权方协同管理平台';

// 获取外包项目标题（IP 服务场景返回 IP 合作版权方标题）
function getOuterTitle(): string {
  return isOuterIpService() ? IP_OUTER_TITLE : OUTER_TITLE;
}

export {
  $sType,
  setSType,
  isProdHostName,
  getSeverType,
  isOuterIpService,
  isIpProdHostName,
  getOuterTitle,
};
